<div class="cash-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">calculate</mat-icon>
      <div>
        <h2 mat-dialog-title class="title-text">{{ data.title }}</h2>
        <span class="subtitle-text">{{ data.subtitle ?? 'Nombre de pièces et de billets, chiffres seuls' }}</span>
      </div>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" aria-label="Fermer" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <app-cash-count-grid [counts]="data.counts" (lastEnter)="apply()" />
    @if (data.hint) { <div class="note">{{ data.hint }}</div> }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button type="button" (click)="clear()" class="btn-clear">Tout effacer</button>
    <span class="spacer"></span>
    <button mat-button type="button" (click)="cancel()">Annuler</button>
    <button mat-flat-button color="primary" type="button" (click)="apply()" [disabled]="grid.invalid" class="btn-submit" id="count-apply">
      <mat-icon>check</mat-icon>
      <span>Reporter {{ grid.money(grid.total) }}</span>
    </button>
  </mat-dialog-actions>
</div>
